import React, { useState } from 'react'
import { CiPlay1 } from 'react-icons/ci';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

const courseSections = [
   {
      id: 1,
      title: 'Course Content',
      lectures: '5 lectures • 87 min',
      items: [
         { id: 1, title: 'Introduction to the User Experience Course', preview: true, questions: '5 question', duration: '03:56' },
         { id: 2, title: 'Getting started with your Adobe XD project', preview: true, questions: '5 question', duration: '03:56' },
         { id: 3, title: 'What is UI vs UX - User Interface vs User Experience vs Product Designer', preview: true, questions: '5 question', duration: '03:56' },
         { id: 4, title: 'Wireframing (low fidelity) in Adobe XD', preview: true, questions: '5 question', duration: '03:56' },
         { id: 5, title: 'Viewing your prototype on a mobile device', preview: true, questions: '5 question', duration: '03:56' },
         { id: 6, title: 'Sharing your design', preview: true, questions: '5 question', duration: '03:56' }
      ]
   },
   {
      id: 2,
      title: 'The Brief',
      lectures: '5 lectures • 87 min',
      items: [
         { id: 1, title: 'Introduction to the User Experience Course', preview: true, questions: '5 question', duration: '03:56' },
         { id: 2, title: 'Getting started with your Adobe XD project', preview: true, questions: '5 question', duration: '03:56' },
         { id: 3, title: 'What is UI vs UX - User Interface vs User Experience vs Product Designer', preview: true, questions: '5 question', duration: '03:56' },
         { id: 4, title: 'Wireframing (low fidelity) in Adobe XD', preview: true, questions: '5 question', duration: '03:56' },
         { id: 5, title: 'Viewing your prototype on a mobile device', preview: true, questions: '5 question', duration: '03:56' },
         { id: 6, title: 'Sharing your design', preview: true, questions: '5 question', duration: '03:56' }
      ]
   },
   {
      id: 3,
      title: 'Type, Color & Icon Introduction',
      lectures: '5 lectures • 87 min',
      items: [
         { id: 1, title: 'Introduction to the User Experience Course', preview: true, questions: '5 question', duration: '03:56' },
         { id: 2, title: 'Getting started with your Adobe XD project', preview: true, questions: '5 question', duration: '03:56' },
         { id: 3, title: 'What is UI vs UX - User Interface vs User Experience vs Product Designer', preview: true, questions: '5 question', duration: '03:56' },
         { id: 4, title: 'Wireframing (low fidelity) in Adobe XD', preview: true, questions: '5 question', duration: '03:56' },
         { id: 5, title: 'Viewing your prototype on a mobile device', preview: true, questions: '5 question', duration: '03:56' },
         { id: 6, title: 'Sharing your design', preview: true, questions: '5 question', duration: '03:56' }
      ]
   },
   {
      id: 4,
      title: 'Prototyping a App - Introduction',
      lectures: '5 lectures • 87 min',
      items: [
         { id: 1, title: 'Introduction to the User Experience Course', preview: true, questions: '5 question', duration: '03:56' },
         { id: 2, title: 'Getting started with your Adobe XD project', preview: true, questions: '5 question', duration: '03:56' },
         { id: 3, title: 'What is UI vs UX - User Interface vs User Experience vs Product Designer', preview: true, questions: '5 question', duration: '03:56' },
         { id: 4, title: 'Wireframing (low fidelity) in Adobe XD', preview: true, questions: '5 question', duration: '03:56' },
         { id: 5, title: 'Viewing your prototype on a mobile device', preview: true, questions: '5 question', duration: '03:56' },
         { id: 6, title: 'Sharing your design', preview: true, questions: '5 question', duration: '03:56' }
      ]
   },
   {
      id: 5,
      title: 'Wireframe Feedback',
      lectures: '5 lectures • 87 min',
      items: [
         { id: 1, title: 'Introduction to the User Experience Course', preview: true, questions: '5 question', duration: '03:56' },
         { id: 2, title: 'Getting started with your Adobe XD project', preview: true, questions: '5 question', duration: '03:56' },
         { id: 3, title: 'What is UI vs UX - User Interface vs User Experience vs Product Designer', preview: true, questions: '5 question', duration: '03:56' },
         { id: 4, title: 'Wireframing (low fidelity) in Adobe XD', preview: true, questions: '5 question', duration: '03:56' },
         { id: 5, title: 'Viewing your prototype on a mobile device', preview: true, questions: '5 question', duration: '03:56' },
         { id: 6, title: 'Sharing your design', preview: true, questions: '5 question', duration: '03:56' }
      ]
   },
];

function Content({ course }) {
   const [expandedSections, setExpandedSections] = useState({});
   const [allExpanded, setAllExpanded] = useState(false);
   const navigate = useNavigate();
   
      const handleLessonClick = (modId, lessonId) => {
         navigate(`/lesson-page/${course.id}/${modId}/${lessonId}`);
      };

   // Vérifier si les modules de l'API sont disponibles
   const hasApiModules = course?.modules && course.modules.length > 0;

   // Utiliser les données de l'API si disponibles, sinon utiliser les données statiques
   const sectionsToDisplay = hasApiModules ? course.modules : courseSections;

   // Calculer les totaux
   const totalSections = sectionsToDisplay.length;
   const totalLectures = hasApiModules
      ? sectionsToDisplay.reduce((total, module) => total + (module.lessons?.length || 0), 0)
      : sectionsToDisplay.reduce((total, section) => total + (section.items?.length || 0), 0);

   // Formater la durée des leçons (pour les données API)
   const formatDuration = (minutes) => {
      if (!minutes) return '00:00';
      const hrs = Math.floor(minutes / 60);
      const mins = minutes % 60;
      return hrs > 0 ? `${hrs}:${mins.toString().padStart(2, '0')}` : `00:${mins.toString().padStart(2, '0')}`;
   };

   // Toggle une section individuelle
   const toggleSection = (sectionId) => {
      setExpandedSections(prev => ({
         ...prev,
         [sectionId]: !prev[sectionId]
      }));
   };

   // Expand/Collapse toutes les sections
   const toggleAllSections = () => {
      if (allExpanded) {
         // Collapse all
         setExpandedSections({});
      } else {
         // Expand all
         const allExpandedState = {};
         sectionsToDisplay.forEach(section => {
            allExpandedState[section.id] = true;
         });
         setExpandedSections(allExpandedState);
      }
      setAllExpanded(!allExpanded);
   };

   // Mettre à jour allExpanded quand expandedSections change
   React.useEffect(() => {
      const allCurrentlyExpanded = sectionsToDisplay.every(section => expandedSections[section.id]);
      setAllExpanded(allCurrentlyExpanded);
   }, [expandedSections, sectionsToDisplay]);

   return (
      <div>
         <h2 className="text-xl font-medium text-gray-900 dark:text-white">Modules</h2>
         <div className="flex justify-between items-center mt-6">
            <div className="text-gray-600 dark:text-gray-400">
               {totalSections} sections • {totalLectures} lectures
            </div>
            <button
               className="text-purple-1 underline"
               onClick={toggleAllSections}
            >
               {allExpanded ? 'Réduire toutes les sections' : 'Développer toutes les sections'}
            </button>
         </div>

         <div className="mt-4 space-y-4">
            {sectionsToDisplay.map(section => (
               <div key={section.id} className="border border-gray-200 dark:border-gray-700 rounded-xl overflow-hidden">
                  <button
                     className="w-full flex justify-between items-center p-6 bg-gray-100 dark:bg-dark-2 cursor-pointer hover:bg-gray-200 dark:hover:bg-dark-3 transition-colors"
                     onClick={() => toggleSection(section.id)}
                  >
                     <div className="flex items-center">
                        {expandedSections[section.id] ? (
                           <FiChevronUp className="w-5 h-5 mr-3 text-gray-600 dark:text-gray-300" />
                        ) : (
                           <FiChevronDown className="w-5 h-5 mr-3 text-gray-600 dark:text-gray-300" />
                        )}
                        <span className="font-medium text-dark-1 dark:text-white">
                           {section.title || section.name}
                        </span>
                     </div>
                     <div className="text-gray-600 dark:text-gray-400">
                        {hasApiModules
                           ? `${section.lessons?.length || 0} lectures • ${section.estimated_duration_minutes || 0} min`
                           : section.lectures
                        }
                     </div>
                  </button>

                  {expandedSections[section.id] && (
                     <div className="p-6 space-y-6">
                        {/* Affichage pour les données API */}
                        {hasApiModules && section.lessons?.map((lesson) => (
                           <div key={lesson.id} className="flex justify-between items-center border-b border-gray-100
                           dark:border-gray-700 pb-4 font-sans">
                              <div className="flex items-center">
                                 <div className="flex justify-center items-center w-8 h-8 rounded-full bg-purple-100
                                 dark:bg-dark-2 text-purple-1 dark:text-purple-400 mr-3">
                                    <CiPlay1 className="w-3 h-3" />
                                 </div>
                                 <span className="text-gray-700 dark:text-gray-300 text-[15px]">{lesson.title}</span>
                              </div>
                              <div className="flex space-x-4 text-purple-1 dark:text-purple-1 text-sm">
                                 {lesson.is_preview && <button className="underline">Preview</button>}
                                 <span>{formatDuration(lesson.duration_minutes)}</span>
                              </div>
                           </div>
                        ))}

                        {/* Affichage pour les données statiques */}
                        {!hasApiModules && section.items?.map((item) => (
                           <div key={item.id} className="flex justify-between items-center border-b border-gray-100
                           dark:border-gray-700 pb-4 font-sans">
                              <button onClick={() => handleLessonClick(section.id, item.id)} className="w-full flex justify-between items-center">
                                 <div className="flex items-center">
                                    <div className="flex justify-center items-center w-8 h-8 rounded-full bg-purple-100
                                 dark:bg-dark-2 text-purple-1 dark:text-purple-400 mr-3">
                                       <CiPlay1 className="w-3 h-3" />
                                    </div>
                                    <span className="text-gray-700 dark:text-gray-300 text-[15px]">{item.title}</span>
                                 </div>
                                 <div className="flex space-x-4 text-purple-1 dark:text-purple-1 text-sm">
                                    <button>{item.questions}</button>
                                    <span>{item.duration}</span>
                                 </div>
                              </button>
                           </div>
                        ))}
                     </div>
                  )}
               </div>
            ))}
         </div>
      </div>
   )
}

export default Content